if (!customElements.get('g-image-show')) {
  class MImageShow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.enable = this.dataset.slideEnable === 'true';
      if (!this.enable) {
        return;
      }
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed);
      this.showArrows = this.dataset.enableArrows === 'true';
      this.showDots = this.dataset.enableDots === 'true';
      this.adaptHeight = this.dataset.slideHeight === 'adapt';
      this.id = this.dataset.id;
      this.sliderContainer = this.querySelector('.swiper-container');

      this.lastVideo = null;
      this.lastActive = null;
      this.timeout = null;
      this.initSlider();
      this.initTab();
    }
    initTab() {
      this.tabs = this.querySelectorAll('[data-trigger]');
      //移动端就退出
      if (!this.tabs.length) return;
      if (GkifyTheme.config.mqlMobile) return;
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          let index = tab.dataset.trigger;
          this.slider.slideToLoop(Number(index));
          //class
          this.tabs?.forEach((tab) => {
            tab.classList.remove('active');
          });
          tab.classList.add('active');
        });
      });
    }
    initSlider() {
      this.slider = new GkifyLibs.Swiper(this.sliderContainer, {
        init: false,
        autoplay: this.autoplay
          ? {
              delay: this.autoplaySpeed * 1000,
              disableOnInteraction: true,
            }
          : false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        fadeEffect: {
          crossFade: true,
        },
        speed: 1000,
        navigation: this.showArrows
          ? {
              nextEl: this.querySelector('.g-slider-controls__button-next'),
              prevEl: this.querySelector('.g-slider-controls__button-prev'),
            }
          : false,
        pagination: this.showDots
          ? {
              el: this.querySelector('.swiper-pagination'),
              clickable: true,
            }
          : false,
        breakpoints: {
          992: {
            threshold: 2,
          },
        },
        on: {
          init() {
            setTimeout(() => {
              window.dispatchEvent(new Event('resize'));
            }, 100);
          },
        },
      });

      this.lastSlide = null;
      this.currentSlide = null;
      this.slider && this.slider.on('init', this.handleChange.bind(this));
      this.slider && this.slider.on('slideChange', this.handleChange.bind(this));
      this.slider.init();

      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', (e) => this.onBlockSelect(e));
      }
    }

    handleChange(swiper) {
      this.lastActive && this.slider.slideToLoop(this.lastActive);
      //class
      this.tabs?.forEach((tab) => {
        tab.classList.remove('active');
        if (Number(tab.dataset.trigger) === swiper.realIndex) {
          tab.classList.add('active');
        }
      });
    }

    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define('g-image-show', MImageShow);
}
